export const GENERATE_BUTTON_LABEL = 'Generate with AI';
export const GENERATE_INLINE_SCHEMA_DOMAIN = 'inline-expression';
export const GENERATE_MODAL_TITLE = 'AI expression generation';

export const GENERATE_DESCRIPTION_LABEL = 'What should this expression do?';
export const GENERATE_DESCRIPTION_PLACEHOLDER =
  'Describe the rule in plain English (e.g. "approve when loan amount is over 100k and credit score is 720 or higher").';

export const GENERATE_WORKING_HELPER = 'Exploring the schema and assembling the expression…';
export const GENERATE_PROGRESS_POLL_INTERVAL_MS = 1500;
export const GENERATE_PROGRESS_TRAIL_LABEL = 'How the model is solving this';
export const GENERATE_PROGRESS_TRAIL_HISTORY_LABEL = 'How the model solved this';
export const GENERATE_PROGRESS_KIND = {
  TOOL_CALL: 'ToolCall',
  VALIDATOR: 'Validator',
  SELF_CORRECT: 'SelfCorrect',
  PHASE: 'Phase',
};
export const GENERATE_PROGRESS_SELF_CORRECT_PREFIX = 'Self-correcting:';
export const GENERATE_FAILED_HELPER = 'Could not generate an expression. Please try again.';
export const GENERATE_VALIDATION_ERRORS_LABEL = 'Validation errors';
export const GENERATE_SUMMARY_LABEL = 'What this expression does';
export const GENERATE_ASSUMPTIONS_LABEL = 'Heads up';
export const GENERATE_PREVIEW_LABEL = 'Preview';
export const GENERATE_PREVIEW_UNAVAILABLE_HELPER =
  'The model returned an expression but it could not be rendered in the editor.';
export const GENERATE_CLARIFY_LABEL = 'The assistant needs more information';
export const GENERATE_CLARIFY_RECOMMENDED_BADGE = 'Recommended';
export const GENERATE_CLARIFY_FREEFORM_TOGGLE_LABEL = 'Or type your own answer';
export const GENERATE_CLARIFY_FREEFORM_PROMPT_LABEL = 'Type your answer';
export const GENERATE_CLARIFY_ANSWER_LABEL = 'Your answer';
export const GENERATE_CLARIFY_ANSWER_PLACEHOLDER = 'Type your answer.';

export const GENERATE_SUBMIT_BUTTON_LABEL = 'Generate';
export const GENERATE_APPLY_BUTTON_LABEL = 'Apply';
export const GENERATE_REFINE_BUTTON_LABEL = 'Refine';
export const GENERATE_CANCEL_BUTTON_LABEL = 'Cancel';
export const GENERATE_RETRY_BUTTON_LABEL = 'Try again';
export const GENERATE_CLARIFY_SUBMIT_BUTTON_LABEL = 'Continue';

export const GENERATE_STATUS = {
  INPUT: 'input',
  WORKING: 'working',
  PREVIEW: 'preview',
  CLARIFY: 'clarify',
  REFINING: 'refining',
  CANDIDATES: 'candidates',
  FAILED: 'failed',
};

export const GENERATE_FEEDBACK_OUTCOME = {
  ACCEPTED: 'Accepted',
  DISCARDED: 'Discarded',
  EDITED_AND_ACCEPTED: 'EditedAndAccepted',
};

const GENERATE_FEEDBACK_TAG = {
  WRONG_FIELD: 'wrong field',
  WRONG_OPERATOR: 'wrong operator',
  WRONG_LITERAL: 'wrong literal',
  OTHER: 'other',
};

export const GENERATE_FEEDBACK_TAGS = [
  { value: GENERATE_FEEDBACK_TAG.WRONG_FIELD, label: 'Wrong field' },
  { value: GENERATE_FEEDBACK_TAG.WRONG_OPERATOR, label: 'Wrong operator' },
  { value: GENERATE_FEEDBACK_TAG.WRONG_LITERAL, label: 'Wrong literal' },
  { value: GENERATE_FEEDBACK_TAG.OTHER, label: 'Other' },
];

export const GENERATE_N_BEST_DEFAULT_REQUEST = 3;

export const GENERATE_OUTCOME = {
  FINAL: 'Final',
  NEEDS_USER_INPUT: 'NeedsUserInput',
  FAILED: 'Failed',
};

export const GENERATE_ROOT_TYPE_NAME = {
  BOOL: 'bool',
  STRING: 'string',
};

export const GENERATE_REFINE_LABEL = 'What should change?';
export const GENERATE_REFINE_PLACEHOLDER =
  'Describe the edit (e.g. "actually use TotalLoanAmount, not CLoanAmount").';
export const GENERATE_REFINE_HELPER =
  'The model will modify the proposed AST instead of starting over.';
export const GENERATE_REFINE_SUBMIT_BUTTON_LABEL = 'Apply refinement';
export const GENERATE_REFINE_BACK_BUTTON_LABEL = 'Back';

export const GENERATE_SHOW_OPTIONS_TOGGLE_LABEL = 'Show options';
export const GENERATE_SHOW_OPTIONS_HELPER =
  'Ask the model for 2-3 alternative expressions side-by-side.';
export const GENERATE_CANDIDATES_LABEL = 'Choose an option';
export const GENERATE_CANDIDATE_INDEX_LABEL = 'Option';
export const GENERATE_CANDIDATE_SELECT_BUTTON_LABEL = 'Use this option';

export const GENERATE_FEEDBACK_PROMPT_LABEL = 'How did this expression do?';
export const GENERATE_FEEDBACK_THUMBS_UP_LABEL = 'Looks right';
export const GENERATE_FEEDBACK_THUMBS_DOWN_LABEL = 'Not what I meant';
export const GENERATE_FEEDBACK_ADD_NOTE_LABEL = 'Add a note';
export const GENERATE_FEEDBACK_HIDE_NOTE_LABEL = 'Hide note';
export const GENERATE_FEEDBACK_COMMENT_PLACEHOLDER =
  'Anything else? (optional, up to 1024 characters)';
export const GENERATE_FEEDBACK_SUBMIT_BUTTON_LABEL = 'Send feedback';
export const GENERATE_FEEDBACK_THANKS_HELPER = 'Thanks for the feedback.';
export const GENERATE_FEEDBACK_FAILED_HELPER = 'Could not send feedback. Please try again.';
export const GENERATE_FEEDBACK_COMMENT_MAX_LENGTH = 1024;

export const GENERATE_FEEDBACK_STATUS = {
  IDLE: 'idle',
  SUBMITTING: 'submitting',
  SUBMITTED: 'submitted',
  ERROR: 'error',
};

export const PREVIEW_ADD_CLAUSE_BUTTON_LABEL = 'Add a clause';
export const PREVIEW_ADD_CLAUSE_HIDE_BUTTON_LABEL = 'Cancel';
export const PREVIEW_ADD_CLAUSE_SUBMIT_BUTTON_LABEL = 'Add clause';
export const PREVIEW_ADD_CLAUSE_PLACEHOLDER =
  'Describe the clause to add (e.g. "borrower is married").';

export const APPLY_UNDO_TOAST_LABEL = 'Applied. Undo?';
export const APPLY_UNDO_BUTTON_LABEL = 'Undo';
export const APPLY_UNDO_TOAST_TIMEOUT_MS = 5000;
